<template>
  <div class="sm-plans__trial">
    <h4>Add a trial period</h4>
    <p>Select the end date of the Trial</p>
    <div class="sm-plans__trial-main">
      <div class="sm-plans__trial-main-links">
        <a
          href="#"
          @click.prevent="setTrialDate('week', 1)"
        >In a week</a>
        <a
          href="#"
          @click.prevent="setTrialDate('week', 2)"
        >In a two weeks</a>
        <a
          href="#"
          @click.prevent="setTrialDate('month', 1)"
        >In a month</a>
        <a
          href="#"
          @click.prevent="setTrialDate('month', 2)"
        >In a two month</a>
      </div>
      <datepicker-wrap
        v-model="trialDate"
        :inline="true"
        :notBefore="new Date()"
      />
    </div>
    <btn-block
      :text="'Add a trial'"
      :class="{'disabled': !trialDate}"
      @click="addTrial"
    />
  </div>
</template>

<script>
import DatepickerWrap from '@/components/DatepickerWrap';

export default {
  name: 'billing-trial',
  components: {
    'datepicker-wrap': DatepickerWrap,
  },
  data() {
    return {
      trialDate: null
    }
  },
  methods: {
    setTrialDate(term, qty) {
      let today = new Date();
      let newDate;

      if (term == 'week')
        newDate = new Date().setDate(today.getDate() + (7 * qty));
      else
        newDate = new Date().setMonth(today.getMonth() + qty);

      this.trialDate = this.$moment(newDate).format('YYYY-MM-DD');
      this.addTrial();
    },
    addTrial() {
      this.$emit('trial', this.trialDate);
    }
  }
}
</script>